import { API } from "aws-amplify";
import {
  manageConnection,
  requestConnection,
  fanUser,
} from "@/graphql/mutations";
import { UtilsUsecase } from "./types";
import { userTypeConvert } from "@/utils/helper";

export async function relationshipUpgradeUsecase(
  payload: any,
  utils: UtilsUsecase
) {
  try {
    await API.graphql({
      query: manageConnection,
      variables: payload,
    });

    await utils.refetch();

    if (payload?.purpose === "ACCEPTED") {
      utils.successModal({
        show: true,
        title: "Relationship upgraded",
        body: payload?.name,
      });
    } else {
      utils.successModal({
        show: true,
        title: "Decline Relationship Upgrade",
        body: "You have successfully declined the relationship upgrade.",
      });
    }
  } catch (error: any) {
    utils.errorModal({
      title: "Error",
      body:
        error?.errors?.[0]?.message ||
        `${payload?.purpose?.toLocaleLowerCase()} change of type connection failed , please try again.`,
      show: true,
      type: "error",
    });
  }
}

export async function connectionRecommendationsUsecase(
  payload: any,
  utils: UtilsUsecase
) {
  try {
    const { recommendToUser: rec } = payload || {};
      if (rec) {
        await API.graphql({
          query: (await import("@/graphql/mutations")).recommendToUser,
          variables: { ...rec, purpose: payload?.purpose },
        });
      }
      
    if (payload?.purpose === "ACCEPTED") {
      await API.graphql({
        query: requestConnection,
        variables: payload?.requestConnection,
      });      
    }

    await utils.refetch();

    if (payload?.purpose === "ACCEPTED") {
      utils.successModal({
        show: true,
        title: `Request Sent.`,
        body: `Congrats! You earned more points by successfully sending a mentorship request for ${payload?.misc?.name} to become your ${payload?.requestConnection?.userToType === "MENTEE" && payload?.requestConnection?.userFromType === "SUPER_MENTOR" ? "Sponsoree" : userTypeConvert(payload?.requestConnection?.userToType)}. You're welcome to cancel this request at any time so you can connect to ${payload?.misc?.name?.trimEnd()}, but mentorships earn more points than connections.`,
      });
    } else {
      utils.successModal({
        show: true,
        title: "Connection Recommendation Declined",
        body: `You successfully declined the recommended connection.`,
      });
    }
  } catch (error: any) {
    utils.errorModal({
      title: "Request Connection Failed",
      body:
        error?.errors?.[0]?.message ||
        "Failed to request connection , please try again.",
      show: true,
      type: "error",
    });
  }
}

export async function connectionActivitiesUsecase(
  payload: any,
  utils: UtilsUsecase
) {
  try {
    await API.graphql({
      query: fanUser,
      variables: { userId: payload?.id, fan: true },
    });

    await utils.refetch();

    if (payload?.purpose === "ACCEPTED") {
      utils.successModal({
        show: true,
        title: "Connection successfully made",
        body: `Congrats! You earned more points by accepting the connection request from ${payload?.userFromName}. You are now connected with ${payload?.userFromName}.`,
      });
    } else {
      utils.successModal({
        show: true,
        title: "Connection successfully declined",
        body: `You have successfully declined the connection request from ${payload?.userFromName}.`,
      });
    }
  } catch (error: any) {
    utils.errorModal({
      title: "Wave failed",
      body:
        error?.errors?.[0]?.message ||
        "There was a problem when wave process, please try again.",
      show: true,
      type: "error",
    });
  }
}
